export default {
  'documentTypes.generateReport': 'Gerar Relatório',
  'documentTypes.create': 'Novo Tipo de Documento',
  'documentTypes.filters.initials': 'Sigla',
  'documentTypes.filters.description': 'Descrição',
  'documentTypes.list.header.initials': 'Sigla',
  'documentTypes.list.header.description': 'Descrição',
  'documentTypes.list.header.actions': 'Ações',
  'documentTypes.list.column.actions.details': 'Ver/Editar',
  'documentTypes.modal.general.new.title': 'Novo Tipo de Documento',
  'documentTypes.modal.general.form.initials': 'Sigla',
  'documentTypes.modal.general.form.description': 'Descrição',
  'documentTypes.modal.general.form.percentRate': 'Taxa Percentual (%)',
  'documentTypes.modal.general.form.creditCard': 'Cartão de Crédito',
  'documentTypes.modal.general.form.debitCard': 'Cartão de Débito',
  'documentTypes.modal.general.form.fiscalDocument': 'Documento Fiscal',
  'documentTypes.modal.general.form.fixedRate': 'Taxa Fixa',
  'documentTypes.modal.general.form.notGenerateFinancial':
    'NÃO GERAR FINANCEIRO',
  'documentTypes.modal.general.form.includeBankAccountInPaymentInstallments':
    'Incluir conta bancária na geração de financeiro',
  'documentTypes.modal.general.form.stoneDocument': 'Documento Stone',
  'documentTypes.modal.general.form.payOnTime':
    'Liquidar automático lançamento à vista',
  'documentTypes.modal.general.form.calculateValue':
    'Calcula valor da tarifa sobre o valor total do financeiro',
  'documentTypes.modal.general.form.bankAccounts': 'Conta Bancária',
  'documentTypes.modal.general.form.planAccounts': 'Plano de Contas Padrão',
  'documentTypes.modal.general.new.message.success':
    'Tipo de Documento criado com sucesso!',
  'documentTypes.modal.general.new.message.error':
    'Erro ao criar Novo Tipo de Documento!',
  'documentTypes.modal.report.title': 'Gerar Relatório',
  'documentTypes.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'documentTypes.modal.report.buttons.pdf': 'Gerar PDF',
  'documentTypes.modal.report.buttons.rtf': 'Gerar RTF',
  'documentTypes.modal.report.buttons.csv': 'Gerar CSV',
  'document.modal.report.form.since': 'De',
  'document.modal.report.form.until': 'Até',
  'document.modal.report.form.description': 'Descrição',
  'document.modal.report.form.fiscalDocument': 'Documento Fiscal',
  'document.modal.report.form.fiscalDocument.yes': 'Sim',
  'document.modal.report.form.fiscalDocument.no': 'Não',
  'documentTypes.rate.list.title': 'Parcelas',
  'documentTypes.rate.list.numberInstallments': 'Qtd. Parcelas',
  'documentTypes.rate.list.percentRate': 'Taxa Percentual (%)',
  'documentTypes.rate.list.header.actions': 'Ações',
  'documentTypes.rate.form.numberInstallments': 'Qtd. Parcelas',
  'documentTypes.rate.form.percentRate': 'Taxa Percentual (%)',
  'documentTypes.remove': 'Excluir Tipo de Documento',
  'documentTypes.remove.alert': 'Deseja deletar o Tipo de Documento?',
  'documentTypes.remove.notification.success': 'Tipo de Documento removido!',
  'documentTypes.remove.notification.success.description':
    'Tipo de Documento removido com sucesso!',
  'documentTypes.remove.notification.error':
    'Erro ao remover Tipo de Documento!',
  'documentTypes.remove.notification.error.description':
    'Occoreu um erro ao remover o Tipo de Documento!',
  'documentTypes.update.notification.success': 'Tipo de documento atualizado!',
  'documentTypes.update.notification.success.description':
    'Tipo de documento atualizado com sucesso',
  'documentTypes.update.notification.error':
    'Erro ao atualizar Tipo de documento',
  'documentTypes.update.notification.error.description':
    'Ocorreu um erro ao atualizar Tipo de documento',
  'documentTypes.rate.remove.modal.title': 'Excluir Parcela',
  'documentTypes.rate.remove.modal.content': 'Deseja excluir a parcela?',
  'documentTypes.rate.remove.notification.success': 'Parcela Excluída',
  'documentTypes.rate.remove.notification.successDescription':
    'Parcela excluída com sucesso',
  'documentType.rate.remove.modal.button.ok': 'Excluir',
  'documentTypes.rate.list.create': 'Criar Parcela',
  'documentTypes.rate.modal.create.title': 'Adicionar Nova Parcela',
  'documentTypes.rate.modal.create.success': 'Parcela adicionada',
  'documentTypes.rate.modal.create.successDescription':
    'Parcela adicionada com sucesso',
  'documentTypes.rate.modal.create.error': 'Erro ao adicionar parcela',
  'documentTypes.rate.modal.create.errorDescription':
    'Ocorreu um erro ao adicionar a parcela',

  'documentTypes.rate.modal.update.title': 'Atualizar Parcela',
  'documentTypes.rate.modal.update.success': 'Parcela atualizada',
  'documentTypes.rate.modal.update.successDescription':
    'Parcela atualizada com sucesso',
  'documentTypes.rate.modal.update.error': 'Erro ao atualizar a parcela',
  'documentTypes.rate.modal.update.errorDescription':
    'Ocorreu um erro ao atualizar a parcela',
  'documentTypes.notification.generate.report.description':
    'Relatório de Tipo de Documento Gerado com Sucesso!',
  'documentTypes.notification.generate.report.title':
    'Relatório gerado com sucesso',

  'documentType.notification.update.status':
    'Status do Tipo de Documentos alterado com sucesso!',

  'documentTypes.modal.selectedDocumentTypes.title.add':
    'Adicionar Tipo de Documento',
  'documentTypes.modal.selectedDocumentTypes.search':
    'Busque os Tipos de Documento',

  'documentTypes.create.error.duplicate.initials':
    'Tipos de Documento já criado com a sigla informada.',
  'documentTypes.create.error.duplicate.description':
    'Tipos de Documento já criado com a descrição informada.',
};
